/*
 * Vehicle Garage — core store module + header chip
 * Vanilla JS, no dependencies. Persists the selected vehicle in localStorage
 * and broadcasts changes so any component can react (header chip, finder, collections).
 *
 * Stored shape (key: "selected_vehicle"):
 *   { slug, url, gid, make, model, generation, engine }
 */
(function () {
  'use strict';

  // Guard against the script being included more than once on a page.
  if (window.VehicleGarage) return;

  var KEY = 'selected_vehicle';
  var listeners = [];

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || null;
    } catch (e) {
      return null;
    }
  }

  function write(value) {
    try {
      if (value) {
        localStorage.setItem(KEY, JSON.stringify(value));
      } else {
        localStorage.removeItem(KEY);
      }
    } catch (e) {
      /* storage unavailable (private mode) — fail silently */
    }
    listeners.forEach(function (cb) {
      try {
        cb(value);
      } catch (e) {}
    });
    document.dispatchEvent(new CustomEvent('vehicle:change', { detail: value }));
  }

  var Garage = {
    KEY: KEY,
    get: read,
    set: function (value) {
      write(value);
    },
    clear: function () {
      write(null);
    },
    /* Build the active faceted-filter query string for collection/search pages. */
    filterParam: function (metafield) {
      var v = read();
      if (!v || !v.gid) return '';
      var key = 'filter.p.m.' + (metafield || 'custom.vehicle_fitment');
      return key + '=' + encodeURIComponent(v.gid);
    },
    subscribe: function (cb) {
      if (typeof cb !== 'function') return;
      listeners.push(cb);
      cb(read());
    }
  };

  window.VehicleGarage = Garage;

  /* ---------- Header chip ---------- */

  function vehicleLabel(v) {
    return [v.make, v.generation, v.engine].filter(Boolean).join(' ');
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : str;
    return d.innerHTML;
  }

  function renderChips() {
    var hosts = document.querySelectorAll('[data-vehicle-garage]');
    if (!hosts.length) return;
    var v = read();

    hosts.forEach(function (host) {
      if (!v) {
        host.hidden = true;
        host.innerHTML = '';
        return;
      }
      host.hidden = false;
      host.innerHTML =
        '<span class="vg__label">O meu veículo:</span>' +
        '<a class="vg__name" href="' + (v.url || '#') + '">' + escapeHtml(vehicleLabel(v)) + '</a>' +
        '<button type="button" class="vg__action" data-vg-change aria-label="Mudar de veículo">Mudar de veículo</button>' +
        '<button type="button" class="vg__action vg__action--clear" data-vg-clear aria-label="Limpar veículo">Limpar</button>';
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vg-clear]')) {
      Garage.clear();
      return;
    }
    if (e.target.closest('[data-vg-change]')) {
      e.preventDefault();
      var anchor = document.getElementById('vehicle-finder-anchor');
      if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        window.location.href = '/';
      }
    }
  });

  /* ---------- Collection / search filter banner ---------- */

  function currentParams() {
    return new URLSearchParams(window.location.search);
  }

  function renderBanners() {
    var hosts = document.querySelectorAll('[data-vehicle-filter-banner]');
    if (!hosts.length) return;
    var v = read();

    hosts.forEach(function (host) {
      var metafield = host.getAttribute('data-metafield') || 'custom.vehicle_fitment';
      var filterKey = 'filter.p.m.' + metafield;

      if (!v || !v.gid) {
        host.hidden = true;
        host.innerHTML = '';
        return;
      }

      var params = currentParams();
      var isFiltered = params.get(filterKey) === v.gid;
      host.hidden = false;

      var name = escapeHtml(vehicleLabel(v));
      if (isFiltered) {
        var off = currentParams();
        off.delete(filterKey);
        host.innerHTML =
          '<span class="vfb__text">A mostrar peças para <strong>' + name + '</strong></span>' +
          '<a class="vfb__action" href="' + window.location.pathname + (off.toString() ? '?' + off.toString() : '') + '">Mostrar todas as peças</a>';
      } else {
        var on = currentParams();
        on.set(filterKey, v.gid);
        host.innerHTML =
          '<span class="vfb__text">Tem <strong>' + name + '</strong> na sua garagem</span>' +
          '<a class="vfb__action vfb__action--primary" href="' + window.location.pathname + '?' + on.toString() + '">Mostrar apenas compatíveis</a>';
      }
    });
  }

  function renderAll() {
    renderChips();
    renderBanners();
  }

  Garage.subscribe(renderAll);

  if (document.readyState !== 'loading') {
    renderAll();
  } else {
    document.addEventListener('DOMContentLoaded', renderAll);
  }
})();
